import { MarkdownContent } from '@backstage/core-components';
import { RemoteDocBlock } from './types';
import { transformImageUri } from './transformImageUri';
import { MermaidDiagram } from './MermaidDiagram';

/** Pinta los bloques del documento: markdown con el estilo estándar de Backstage;
 * mermaid, como diagrama renderizado (con carga diferida de la librería). */
export const RemoteDocBlocks = ({ blocks }: { blocks: RemoteDocBlock[] }) => (
  <>
    {blocks.map((block, i) =>
      block.type === 'mermaid' ? (
        <MermaidDiagram key={i} code={block.content} />
      ) : (
        <MarkdownContent
          key={i}
          content={block.content}
          linkTarget="_blank"
          transformImageUri={transformImageUri}
        />
      ),
    )}
  </>
);
